import {
	cookieRemove,
	cookieWrite,
	getAkeyV3,
	getParamsOrCookie,
	getVersion,
	getSmartPlatform,
	getSmartWebview,
	isValidValue,
	isWebview as checkIsWebview,
	readArgv,
	readCookie,
	readParams,
	cookieDomain,
} from "./common.js";

export let cookie = {};
export let params = {};
export let argv = {};
export let akey = "";
export let smartWebview = "";
export let smartPlatform = "";
export let isWebview = false;

const setCookiePath = () => {
	const params = new URLSearchParams(window.location.search);
	if (isValidValue(params.get("path"))) {
		cookieWrite("path", params.get("path"), 0.002);
	}
	if (isValidValue(params.get("fm"))) {
		cookieWrite("fm", params.get("fm"), 0.01);
	} else {
		cookieRemove("fm");
	}
	if (isValidValue(params.get("ver"))) {
		cookieWrite("ver", params.get("ver"), 1);
	}
};

const setCookieAWSNotification = () => {
	/*id4vendor (iOS)*/
	const id4vendor = getParamsOrCookie("id4vendor");
	if (isValidValue(id4vendor)) {
		cookieWrite("id4vendor", id4vendor);
	}
	/*android id (android)*/
	const androidid = getParamsOrCookie("androidid");
	if (isValidValue(androidid)) {
		cookieWrite("androidid", androidid);
	}
};

const setCookieAppOption = () => {
	/* gps incorrect */
	const argv = readArgv();
	const gpsIncorrect = argv.gps_incorrect;
	if (isValidValue(gpsIncorrect)) {
		cookieWrite("gps_incorrect", gpsIncorrect);
	}
};

const setCookieAkey = (akey) => {
	const authKey = akey || getAkeyV3();
	if (authKey) {
		cookieWrite("akey", authKey, 366);
	}
};

export const init = ({cookieDomain: customCookieDomain} = {}) => {
	if (typeof window === "undefined") {
		cookie = {};
		params = {};
		argv = {};
		akey = "";
		return;
	}
	if (customCookieDomain) {
		cookieDomain.value = customCookieDomain;
	}
	setCookiePath();
	setCookieAWSNotification();
	setCookieAppOption();
	setCookieAkey();

	cookie = readCookie();
	params = readParams();
	argv = readArgv();
	akey = getAkeyV3();
	smartWebview = getSmartWebview();
	smartPlatform = getSmartPlatform();
	isWebview = checkIsWebview();
};
